const ACTIVATION_EVENTS = {
  user_created_list: null,
  user_exported_report: null,
  user_clicked_filters: (props) =>
    props.view === 'gen_pipe' || props.view === 'close_deals',
  user_ran_report: (props) => props.event_site === 'account_mapping_page',
};

export function getActivationTrigger(event) {
  if (!(event.name in ACTIVATION_EVENTS)) return null;
  const predicate = ACTIVATION_EVENTS[event.name];
  if (predicate && !predicate(event.properties || {})) return null;
  return event.name;
}
